module.exports = __webpack_public_path__ + "static/foam-d7802ea03d58e459f2cba1f620920fe2.jpg";